var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shopping-cart",
  clipPath: "url(#clip0_4759_29551)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector ",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.125 0.5C0.125 0.292893 0.292893 0.125 0.5 0.125H2.5C2.67874 0.125 2.83263 0.251144 2.86771 0.426404L3.30775 2.625H11.5C11.6118 2.625 11.7177 2.67485 11.7889 2.76096C11.8602 2.84707 11.8893 2.96047 11.8684 3.07025L11.0678 7.26806C11.005 7.58458 10.8328 7.8689 10.5814 8.07126C10.331 8.27281 10.018 8.38025 9.69668 8.375H4.84332C4.52203 8.38025 4.20899 8.27281 3.95862 8.07126C3.70737 7.869 3.53522 7.58485 3.47227 7.2685L2.63628 3.09164C2.63336 3.08002 2.63098 3.06819 2.62918 3.05618L2.19262 0.875H0.5C0.292893 0.875 0.125 0.707107 0.125 0.5ZM3.45787 3.375L4.20782 7.12194C4.23639 7.26582 4.31466 7.39506 4.42892 7.48704C4.54318 7.57902 4.68616 7.62788 4.83282 7.62507L4.84 7.625H9.7L9.70718 7.62507C9.85384 7.62788 9.99682 7.57902 10.1111 7.48704C10.225 7.39532 10.3032 7.26655 10.3319 7.12316L10.3322 7.12194L11.0467 3.375H3.45787ZM3.62502 10.5C3.62502 10.0168 4.01677 9.62502 4.50002 9.62502C4.98327 9.62502 5.37502 10.0168 5.37502 10.5C5.37502 10.9833 4.98327 11.375 4.50002 11.375C4.01677 11.375 3.62502 10.9833 3.62502 10.5ZM9.125 10.5C9.125 10.0168 9.51675 9.62502 10 9.62502C10.4832 9.62502 10.875 10.0168 10.875 10.5C10.875 10.9833 10.4832 11.375 10 11.375C9.51675 11.375 9.125 10.9833 9.125 10.5Z",
  fill: "#00538F"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4759_29551"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white"
})));

function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.22d4efe9.svg";
export { ForwardRef as ReactComponent };